import { FAILURE, REQUEST, SUCCESS } from '@/constants';

export default action => ({
  [FAILURE]: `${action}/${FAILURE}`,
  [REQUEST]: `${action}/${REQUEST}`,
  [SUCCESS]: `${action}/${SUCCESS}`,
});
